export default {
  // Welcome
  "notify.welcome.title": "Welcome to VendeYa! 🎉",
  "notify.welcome.message":
    "Your account was created successfully. You can now start exploring products, saving favorites, and making purchases.",
  "notify.welcome.verify":
    "We sent you an email to confirm your email address. Check your inbox.",

  // Seller application
  "notify.seller.submitted.title": "Application submitted! 🎉",
  "notify.seller.submitted.message":
    "We received your application to become a VendeYa seller. Our team will review the information provided and notify you when your application is approved.",
  "notify.seller.submitted.state": "Application pending review",
  "notify.seller.submitted.note":
    "You can keep using VendeYa normally while we review your application.",

  "notify.seller.incomplete.title": "You can't submit the application yet",
  "notify.seller.incomplete.message":
    "There is required information you must complete before submitting your seller application.",
  "notify.seller.incomplete.cta": "Complete application",

  "notify.seller.verification.title": "You need to complete your verification",
  "notify.seller.verification.message":
    "To request seller approval you must complete the required documentation.",

  "notify.seller.review.title": "Application under review",
  "notify.seller.review.message": "Your application is being reviewed by the VendeYa team.",

  "notify.seller.approved.title": "🎉 Congratulations! You are now a VendeYa seller",
  "notify.seller.approved.message":
    "Your application was approved. You can now start publishing your items and selling on VendeYa.",
  "notify.seller.approved.cta": "Publish my first item",

  "notify.seller.rejected.title": "Your seller application was not approved",
  "notify.seller.rejected.message": "For now we cannot approve your application.",
  "notify.seller.rejected.reason": "Rejection reason:",
  "notify.seller.rejected.cta": "Fix application",

  "notify.seller.suspended.title": "Your seller account was suspended",
  "notify.seller.suspended.message":
    "Your ability to publish and sell has been temporarily suspended.",
  "notify.seller.suspended.reason": "Reason:",
  "notify.seller.suspended.cta": "View details",

  "notify.seller.notSeller.title": "You must become a seller first",
  "notify.seller.notSeller.message":
    "To publish items you need an approved seller account.",
  "notify.seller.notSeller.cta": "Sign up as a seller",

  "notify.seller.pendingPublish.title": "Your account is still under review",
  "notify.seller.pendingPublish.message":
    "You already applied to become a seller, but your application is still being reviewed. You'll be able to publish once it is approved.",
  "notify.seller.pendingPublish.cta": "View application status",

  // Publishing and tickets
  "notify.publish.noTicket.title": "⚠️ Verification ticket missing",
  "notify.publish.noTicket.message":
    "This item cannot be published yet because it must have a verification ticket generated by VendeYa.",
  "notify.publish.noTicket.explain":
    "The cover photo can be used as the product's main image, but the additional gallery photos must include the corresponding ticket.",
  "notify.publish.noTicket.cta": "Add photos",

  "notify.publish.galleryNoTicket.title": "This photo does not meet the requirements",
  "notify.publish.galleryNoTicket.message":
    "All gallery photos must show the same verification ticket assigned to this item.",

  "notify.publish.wrongTicket.title": "The ticket does not match",
  "notify.publish.wrongTicket.message":
    "This photo contains a different ticket than the one assigned to this item.",

  "notify.publish.ticketRequired": "Ticket required:",
  "notify.publish.correctTicket": "Correct ticket:",

  "notify.publish.cover.label": "Cover image",
  "notify.publish.cover.description":
    "This image can be used as the promotional cover of the item.",

  "notify.publish.ticketGenerated.title": "Ticket generated successfully! 🎟️",
  "notify.publish.ticketGenerated.message": "This ticket identifies your item within VendeYa.",
  "notify.publish.ticketGenerated.cta": "Continue with the photos",

  "notify.publish.published.title": "🎉 Item published!",
  "notify.publish.published.message":
    "Your item is now available on VendeYa and can be found by buyers.",
  "notify.publish.published.ctaView": "View listing",
  "notify.publish.published.ctaOther": "Publish another item",

  "notify.publish.draft.title": "Draft saved",
  "notify.publish.draft.message":
    "Your item was saved as a draft. You can keep editing it whenever you want.",

  // Images
  "notify.image.uploadError.title": "We couldn't upload the image",
  "notify.image.uploadError.message":
    "The image could not be loaded correctly. Check your internet connection and try again.",
  "notify.image.format.title": "Unsupported format",
  "notify.image.format.message":
    "This file type is not allowed. Use JPG, JPEG, PNG, or WEBP.",
  "notify.image.tooBig.title": "The image is too large",
  "notify.image.tooBig.message":
    "This image exceeds the maximum allowed size. Select a smaller image.",

  // Profile
  "notify.profile.updated.title": "Profile updated!",
  "notify.profile.updated.message": "Your profile changes were saved successfully.",
  "notify.profile.avatar.title": "Profile photo updated!",
  "notify.profile.avatar.message": "Your new profile photo is now visible on VendeYa.",
  "notify.profile.cover.title": "Cover updated!",
  "notify.profile.cover.message": "Your new cover photo is now visible on your profile.",

  // Password
  "notify.password.sent.title": "Check your email",
  "notify.password.sent.message": "We sent you a secure link to change your password.",
  "notify.password.updated.title": "🔐 Password updated",
  "notify.password.updated.message": "Your password was changed successfully.",

  // Membership
  "notify.membership.active.title": "🎉 You are now verified!",
  "notify.membership.active.message":
    "Your VendeYa Verified membership is active. Your profile will now show the blue verification badge.",
  "notify.membership.active.badge": "✓ Verified",
  "notify.membership.expiring.title": "Your membership is about to expire",
  "notify.membership.expiring.message":
    "Your VendeYa Verified membership expires on {{date}}. Renew to keep your verification badge.",
  "notify.membership.expiring.cta": "Renew membership",
  "notify.membership.expired.title": "Your membership has expired",
  "notify.membership.expired.message":
    "Your VendeYa Verified membership is no longer active and the blue badge was removed.",
  "notify.membership.expired.cta": "Verify me again",

  // Orders and payments
  "notify.order.completed.title": "🎉 Purchase completed successfully!",
  "notify.order.completed.message": "Your payment was confirmed and your order was registered.",
  "notify.order.completed.cta": "View my order",
  "notify.order.paymentFailed.title": "We couldn't complete the payment",
  "notify.order.paymentFailed.message":
    "The payment was not approved. We have not confirmed this order.",
  "notify.order.paymentFailed.cta": "Try again",
  "notify.order.shipped.title": "📦 Your order is on its way!",
  "notify.order.shipped.message": "The seller has shipped your order.",
  "notify.order.delivered.title": "🎉 Order delivered!",
  "notify.order.delivered.message": "Your order was marked as delivered.",
  "notify.order.delivered.cta": "View order",

  // Favorites and cart
  "notify.favorite.added": "❤️ Added to favorites",
  "notify.favorite.removed": "Removed from favorites",
  "notify.cart.added.title": "🛒 Product added to cart",
  "notify.cart.added.message": "The item was added successfully.",

  // Security
  "notify.security.title": "⚠️ Security activity",
  "notify.security.message":
    "We detected unusual activity on your account. If you don't recognize this activity, review your account security immediately.",

  // Administrative actions
  "notify.admin.approved": "Seller approved successfully.",
  "notify.admin.rejected": "Application rejected successfully.",
  "notify.admin.suspended": "Seller suspended successfully.",
  "notify.admin.blocked": "User blocked successfully.",
  "notify.admin.restored": "User reactivated successfully.",
  "notify.admin.permissions": "Permissions updated successfully.",

  // Notification center
  "notifications.title": "Notifications",
  "notifications.subtitle": "All the news about your account and your items.",
  "notifications.all": "All",
  "notifications.unread": "Unread",
  "notifications.markAll": "Mark all as read",
  "notifications.empty": "You have no notifications",
  "notifications.emptyDesc": "When something important happens, we'll show it here.",
};